import { DOCUMENT_KEYS, DOCUMENT_TYPES } from '../components';
import { isClassApproved, isClassReady } from '../utils';
import { getMissingDocumentsByKlass, getMissingDocumentsByType } from '../utils/getMissingDocumentsCount';
import { totalInvalidDocuments, totalDocuments } from './utils';

const filterByClass = ({ documents, klass }) => documents.filter(
  (document) => document.documentClass === DOCUMENT_KEYS[klass],
);
const filterByType = ({ documents, type }) => documents.filter(
  (document) => document.documentType === DOCUMENT_KEYS[type],
);

const parseDocByKlass = ({
  documents, klass, paymentFrequency, requisitionStatus,
}) => {
  const classDocuments = filterByClass(
    { documents, klass },
  );

  const {
    missingCount,
    uploadedCount,
  } = getMissingDocumentsByKlass({
    klass,
    documents,
    paymentFrequency,
  });

  return {
    klass,
    missingCount,
    uploadedCount,
    requisitionStatus,
    documents: classDocuments,
    type: DOCUMENT_TYPES[klass],
    uploadedDocuments: totalDocuments(classDocuments),
    invalidDocuments: totalInvalidDocuments(classDocuments),
    areGroupDocsReady: isClassReady(klass, documents, paymentFrequency),
    areGroupDocsApproved: isClassApproved(klass, documents, paymentFrequency),
  };
};

const parseDocByType = ({
  documents, type, paymentFrequency, requisitionStatus, notPreferred,
}) => {
  const classDocuments = filterByType(
    { documents, type },
  );

  const {
    missingCount,
    uploadedCount,
  } = getMissingDocumentsByType({
    type,
    documents,
    paymentFrequency,
  });

  return {
    notPreferred,
    missingCount,
    uploadedCount,
    requisitionStatus,
    documents: classDocuments,
    type: DOCUMENT_TYPES[type],
    uploadedDocuments: totalDocuments(classDocuments),
    invalidDocuments: totalInvalidDocuments(classDocuments),
    areGroupDocsReady: isClassReady(type, documents, paymentFrequency),
    areGroupDocsApproved: isClassApproved(type, documents, paymentFrequency),
  };
};

export const useParseDocumentInfo = () => ({
  parseDocByType,
  parseDocByKlass,
});
